import React, { useState, useEffect } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  tableConfig,
  filters as rawFilters,
} from "@screens/system/menu-items/menu-items-list/model/menu-items-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
  getParamsData,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteMenuItemsDataApi,
  getMenuItemsDataApi,
} from "./menu-items-list.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import MenuItemsListTemplateComponent from "./menu-items-list-template.component";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { END_POINT } from "@constants/api.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MENU_ITEMS_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const MenuItemsListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const tableParams = getParamsData(filterList, menuUrl);
  const { token } = useSelector((state) => state.app);
  const { MENU_ITEMS_EXPORT } = END_POINT;

  const getMenuItemData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const menuItemData = await getMenuItemsDataApi({
      ...params,
      filters: queryStr,
    });
    if (menuItemData.status) {
      // console.log(menuItemData);
      setTableData(menuItemData.data);
      setTotalCount(menuItemData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteMenuItemsDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getMenuItemData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getMenuItemData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    const type = "download";
    console.log("download triggered", filters, queryStr);
    window.open(`${MENU_ITEMS_EXPORT}/${type}?token=${token}${queryStr}`);
  };

  const handleTemplateDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    const type = "template";
    console.log({ type });
    window.open(`${MENU_ITEMS_EXPORT}/${type}?token=${token}${queryStr}`);
  };

  return menuAccess ? (
    <MenuItemsListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        tableConfig,
        filters: filters ? filters : rawFilters,
        tableParams,
      }}
      templateEvents={{
        getMenuItemData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
        handleTemplateDownload,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default MenuItemsListComponent;
